import { useContext, useEffect, useRef, useState } from "react";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import ParentData from "../../components/ParentData";
import ChildrenData from "../../components/ChildrenData";
import CommonAdvantages from "../../components/CommonAdvantages";
import Wishes from "../../components/Wishes";
import { validateDublicateChildrenNames, validateLnchYearsFromSelectedDate, validateTwin, validateWishes } from "../../utils/Validations";
import { EgnValid } from "../../utils/EgnValidator";
import { AdditionalInfo } from "../../components/AdditionalInfo";
import Swal from 'sweetalert2';
import bcrypt from "bcryptjs-react";
import * as fileService from '../services/fileService'
import { RegisterContext } from "../../contexts/RegisterContext";
import { checkIsOpenForRegister } from '../services/RankingService';
import { MunicipalityRegisterBodyFormat, StringToDate } from "../../utils/RegisterApplicationBodyFormatter";
import { WishValidatorContext } from "../../contexts/WishValidatorContext";
import { AddressContext } from "../../contexts/AddressContext";
import { createFreeAddressTextApplication, createMunicipalityApplication } from '../services/applicationService';
import { ParameterContext } from "../../contexts/ParameterContext";
import { SedentaryGroup } from "../../components/SedentaryGroup";
import { AuthContext } from "../../contexts/AuthContext";
import { Link } from 'react-router-dom';

export const MunicipalityREgisterForm = () => {
    const cyrillicRegex = /^(?!\s)(?:[\u0400-\u04FF0-9-]|\s(?!\s))*[\u0400-\u04FF0-9-] ?$/;
    const cyrillicAddressesRegex = /^(?!\s)(?:[\u0400-\u04FF0-9-.]|\s(?!\s))*[\u0400-\u04FF0-9-.]?$/;
    const phoneRegex = /^\d+$/;

    const parentDataRef = useRef(null);
    const childrenDataRef = useRef(null);
    const commonAdvantagesRef = useRef(null);
    const wishesRef = useRef(null);
    const additionalRef = useRef(null);

    const roles = ['Admin', 'SuperAdmin', 'Municipality', 'Director'];

    const { isFormValid, toggleFormToValid, toggleFormToInvalid, commonAdvantages, advantages, sedentaryGroups, schools } = useContext(RegisterContext);
    const { validateSiblingEGN, removeError } = useContext(WishValidatorContext);
    const { user } = useContext(AuthContext);
    const [isOpenForRegister, setIsOpenForRegister] = useState(false);
    const { validateSibling,
        searchAdvantageSchools,
        validateAddressResidence,
        addressResidence,
        isChildHavePreparatoryGroup,
        cleanChildHavePreparatoryGroupState,
        dontHaveCompletedGroup,
        siblingIsValid,
        parentEgnExist,
        checkParentEgnIfExist,
        getParentDataIfExist,
        parentData,
        validateAddressResidenceByEgn
    } = useContext(AddressContext);
    const { parameters } = useContext(ParameterContext);

    const [loading, setLoading] = useState(false);
    const [regId, setRegId] = useState(null);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        parentIsEgn: '1',
        parentEgn: '',
        parentName: '',
        parentPhone: '',
        parentEmail: user.role == 'Parent' ? user.email : '',
        childIsEgn: '1',
        childEgn: '',
        childName: '',
        twins: [],
        commonAdvantages: [],
        currentAddress: addressResidence.length > 0 ? addressResidence.find(x => x.currenT_ADDR == 2).addresS_TEXT : '',
        currentAddressDate: addressResidence.length > 0 ? new Date(addressResidence.find(x => x.currenT_ADDR == 2).residence) : null,
        permanentAddress: addressResidence.length > 1 ? addressResidence.find(x => x.currenT_ADDR == 1).addresS_TEXT : '',
        permanentAddressDate: addressResidence.length > 1 ? new Date(addressResidence.find(x => x.currenT_ADDR == 1).residence) : null,
        dontHavePermanentAddress: false,
        dontHaveCurrentAddress: false,
        wishes: [{ id: '', school: '' }],
        password: '',
    })

    let priemYear;
    let maxDesires;
    let testReg;
    let dirDisableChildData;
    let autoTimeLived;
    let openForMun;


    if (parameters && parameters.nomParameters) {
        const parameterPriemYear = parameters.nomParameters.find(x => x.param_name == 'PRIEM_YEAR');
        const maxDesiresParam = parameters.nomParameters.find(x => x.param_name == 'DESIRE_MAX');
        const testRegParam = parameters.nomParameters.find(x => x.param_name == 'TEST_REG');
        const dirDisableChildDataParam = parameters.nomParameters.find(x => x.param_name == 'DIR_DISABLE_CIHLD_DATA');
        const autoTimeLivedParam = parameters.nomParameters.find(x => x.param_name == 'AUTOMATIC_TIME_LIVED');
        const openForMunParam = parameters.nomParameters.find(x => x.param_name == 'OPEN_FOR_MUN');


        maxDesires = maxDesiresParam ? maxDesiresParam.value : 10;
        dirDisableChildData = dirDisableChildDataParam ? dirDisableChildDataParam.value : 2
        testReg = testRegParam ? testRegParam.value : 0;
        priemYear = parameterPriemYear ? parameterPriemYear.value : new Date().getFullYear()
        autoTimeLived = autoTimeLivedParam ? autoTimeLivedParam.value : 0;
        openForMun = openForMunParam ? openForMunParam.value : 0;

    } else {
        priemYear = new Date().getFullYear();
        testReg = 0;
        dirDisableChildData = 2;
        autoTimeLived = 0;
        openForMun = 0;
    }

    useEffect(() => {
        //console.log(formData)
        if (addressResidence.length > 0) {
            setFormData(state => {
                const currAddress = addressResidence.find(x => x.currenT_ADDR == 2);
                const permanentAddress = addressResidence.find(x => x.currenT_ADDR == 1)

                const newState = {
                    ...state,
                    currentAddress: addressResidence.length > 0 ? currAddress.addresS_TEXT : '',
                    currentAddressDate: addressResidence.length > 0 && currAddress.residence ? new Date(currAddress.residence) : null,
                    permanentAddress: addressResidence.length > 1 ? permanentAddress.addresS_TEXT : '',
                    permanentAddressDate: addressResidence.length > 1 && permanentAddress.residence ? new Date(permanentAddress.residence) : null,
                    childLnchDate: addressResidence && StringToDate(addressResidence[0].datE_R)
                };

                if (dirDisableChildData == 1 && user.role == 'Director') {
                    newState.childName = currAddress.chilD_NAME;
                }

                return newState;
            })

            setErrors(state => ({
                ...state,
                validAddressResidance: null
            }))

        }

        setFormData(state => ({
            ...state,
            wishes: [{ id: '', school: '' }],
        }))
    }, [addressResidence])

    useEffect(() => {
        let formDataKeys = Object.keys(formData);
        let formDataValues = formDataKeys.map(key => {

            if (key == 'currentAddressDate') {
                if (!formData.dontHaveCurrentAddress) {
                    return formData[key];
                }

                return;
            }

            if (key == 'permanentAddressDate') {
                if (!formData.dontHavePermanentAddress) {
                    return formData[key];
                }

                return;
            }

            if (key == 'password') {
                if (!parentEgnExist) {
                    return formData[key];
                }

                return
            }

            return formData[key];
        });
        
        if (!isFormValid) {
            if (formDataValues.every(x => x !== null && x !== '')) {
                if (validateWishes(formData)) {
                    if (roles.includes(user.role)) {
                        if (formData.wishes.every(x => x.sedGroup) || (autoTimeLived == 1 && user.role == 'Director')) {
                            toggleFormToValid();
                            setErrors({});
                        }
                    } else {
                        toggleFormToValid();
                        setErrors({});
                        // console.log('VALID ');
                    }
                }
            }

        }
       
        if (formDataValues.every(x => x == null || x == '')) {
            toggleFormToInvalid()
        }

        if (formData.wishes.some(x => !x.sedGroup) && autoTimeLived == 0) {
            toggleFormToInvalid()
        }

        if (formData.wishes.some(x => !x.sedGroup) && autoTimeLived == 1 && addressResidence.length == 0) {
            toggleFormToInvalid()
        }

        if (formData.twins.length > 0 && Object.values(formData.twins).some(x => x.twinEgn == '' || x.twinName == '')) {
            toggleFormToInvalid();
        }

        handleErrorLnch();

        console.log('validaciqta ', formData)
    }, [formData])

    useEffect(() => {
        setFormData(state => ({
            ...state,
            commonAdvantages: commonAdvantages.reduce((acc, x) => {
                acc[x.code] = false;
                return acc;
            }, {}),
        }))
    }, [commonAdvantages])

    useEffect(() => {
        setFormData(prevState => {
            const newState = { ...prevState };
            const firstWish = { ...newState.wishes[0] };

            const advantagesMap = advantages.reduce((acc, x) => {
                if (x.code === 'K100') {
                    acc['K100_NAME'] = '';
                    acc['K100_EGN'] = '';
                    acc['K100_IsEgn'] = true;
                } else if (x.code === 'K200') {
                    acc['K200_NAME'] = '';
                    acc['K200_EGN'] = '';
                    acc['K200_IsEgn'] = true;
                } else {
                    acc[x.code] = false;
                }
                return acc;
            }, {});

            newState.wishes[0] = {
                ...firstWish,
                ...advantagesMap,
            };

            return newState;
        });
    }, [advantages])

    useEffect(() => {
        document.title = `Регистрация`;

        setLoading(true)
        checkIsOpenForRegister()
            .then((data) => {
                if (data.status === 400) {
                    setIsOpenForRegister(false);
                }
                else {
                    if (openForMun == 1 && (user.role == 'Municipality' || user.role == 'Admin' || user.role == 'SuperAdmin')) {
                        setIsOpenForRegister(true);
                        setLoading(false)
                    } else {
                        setIsOpenForRegister(data);
                        setLoading(false);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                setIsOpenForRegister(false);
                setLoading(false)
            })
    }, []);

    useEffect(() => {
        if (parentEgnExist || parentEgnExist === false) {
            getParentDataIfExist(formData.parentEgn)
        }
    }, [parentEgnExist]);

    useEffect(() => {
        if (addressResidence.length > 0) {
            if (formData.childIsEgn == '1') {
                const permanentAddress = addressResidence.find(x => x.currenT_ADDR == 1);
                const currentAddress = addressResidence.find(x => x.currenT_ADDR == 2);
               
                searchAdvantageSchools(permanentAddress.addresS_ID, currentAddress.addresS_ID)
            } else if (formData.childIsEgn == '0' && formData.currentAddress) {
                const currentAddress = addressResidence.find(x => x.currenT_ADDR == 2);

                searchAdvantageSchools(null, currentAddress.addresS_ID)
            }
        }

    }, [addressResidence])

    useEffect(() => {
        if (parentData.egn) {
            Swal.fire({
                title: 'Внимание!',
                text: 'Потребителят вече съществува в системата. Данните за родител ще бъдат автоматично заредени.',
                icon: 'warning',
                confirmButtonText: 'ОК'
            })

            setFormData(state => ({
                ...state,
                parentEgn: parentData.egn,
                parentEmail: parentData.email,
                parentName: parentData.name,
                parentPhone: parentData.phone,
                parentIsEgn: EgnValid(parentData.egn) ? '1' : '0'
            }))
        }
    }, [parentData])

    const cleanSiblingInputFields = (e, i, advCode) => {
        setFormData(state => {
            let wishes = [...state.wishes];

            wishes[i][`${advCode}_EGN`] = '';
            wishes[i][`${advCode}_NAME`] = '';

            return { ...state, wishes };
        })
    }

    const handleErrorLnch = () => {
        if ((formData.childIsEgn == '0' && validateLnchYearsFromSelectedDate(formData.childLnchDate, priemYear)) || formData.childIsEgn == '1') {
            setErrors(state => ({
                ...state,
                childLnchDate: ''
            }))
        } else {

            setErrors(state => ({ ...state, childLnchDate: 'Възрастта на детето трябва да бъде между 6 и 8 години!' }))
            toggleFormToInvalid();
        }

        if (formData.twins.length > 0) {
            formData.twins.forEach(x => {
                if ((x.twinIsEgn == '0' && validateLnchYearsFromSelectedDate(x.twinLncDate, priemYear)) || x.twinIsEgn == '1') {
                    setErrors(state => ({
                        ...state,
                        [x.twinNumber]: ''
                    }))
                } else {
                    setErrors(state => ({ ...state, childLnchDate: 'Възрастта на близнака трябва да бъде между 6 и 8 години!' }))
                    toggleFormToInvalid();
                }
            })
        }
    }

    const commonAdvatagesChangeHandler = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        setFormData((prevState) => {
            const commonAdvantages = { ...prevState.commonAdvantages };
            commonAdvantages[fieldName] = e.checked;

            return { ...prevState, commonAdvantages };
        });
    }

    const handleChange = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (i !== undefined && fieldName.includes('twin')) {
            setFormData((prevState) => {
                const twins = [...prevState.twins];

                if ((fieldName.includes('Name') && cyrillicRegex.test(fieldValue) || fieldValue == '')) {
                    twins[i][fieldName] = fieldValue.toUpperCase();
                } else if (fieldName.includes('IsEgn')) {
                    setErrors(state => ({ ...state, [`${i}twinEgn`]: '' }))
                    twins[i][fieldName] = fieldValue;
                } else if (fieldName == 'twinLncDate') {
                    twins[i][fieldName] = fieldValue;
                } else if (!fieldName.includes('Name')) {
                    twins[i][fieldName] = fieldValue.trim();
                }

                return { ...prevState, twins };

            });
        } else if (fieldName.includes('Name') || fieldName.includes('NAME')) {
            if (cyrillicRegex.test(fieldValue) || fieldValue == '') {
                setFormData({
                    ...formData,
                    [fieldName]: fieldValue.toUpperCase(),
                });
            }
        } else if (fieldName.includes('IsEgn')) {
            fieldName == 'parentIsEgn' ? setErrors(state => ({ ...state, parentEgn: '' })) : setErrors(state => ({ ...state, childEgn: '' }))
            setFormData(state => ({
                ...state,
                [fieldName]: fieldValue
            }))
        } else if (fieldName == 'permanentAddress' || fieldName == 'currentAddress') {
            if (cyrillicAddressesRegex.test(fieldValue) || fieldValue == '') {
                let upperValue = fieldValue.toUpperCase();
                setFormData({
                    ...formData,
                    [fieldName]: upperValue,
                });
            }
        } else if (fieldName == 'declarationAcc' || fieldName == 'dontHavePermanentAddress' || fieldName == 'dontHaveCurrentAddress') {
            setFormData(state => {
                let newState = { ...state };
                if (fieldName == 'dontHavePermanentAddress') {
                    newState.permanentAddressDate = null;
                } else if (fieldName == 'dontHaveCurrentAddress') {
                    newState.currentAddressDate = null;
                }

                newState[fieldName] = e.checked;

                return newState;
            })
        } else if (fieldName == 'parentPhone' || fieldName == 'parentEgn' || fieldName == 'childEgn') {
            if (phoneRegex.test(fieldValue) || fieldValue == '') {
                setFormData(state => ({ ...state, [fieldName]: fieldValue }))
            }

            return
        } else if (fieldName == 'childLnchDate' || fieldName == 'permanentAddressDate' || fieldName == 'currentAddressDate') {
            setFormData(state => ({
                ...state,
                [fieldName]: fieldValue
            }))
        } else {
            setFormData(state => ({
                ...state,
                [fieldName]: fieldValue.trim()
            }))
        }
    }

    const onBlurValidate = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (fieldName == 'parentEgn' && formData.parentIsEgn == 1) {
            if (!EgnValid(fieldValue)) {
                setErrors(state => ({ ...state, [fieldName]: 'Въведете валидно ЕГН !' }))
                toggleFormToInvalid();
            } else {
                setErrors(state => ({ ...state, [fieldName]: null }))
                checkParentEgnIfExist(fieldValue);
            }
        } else if (fieldName == 'parentEgn' && formData.parentIsEgn == 0) {
            setErrors(state => ({ ...state, [fieldName]: null }))
            checkParentEgnIfExist(fieldValue);
        } else if (fieldName == 'childEgn' && formData.childIsEgn == 1) {
            if (!EgnValid(fieldValue)) {
                setErrors(state => ({ ...state, [fieldName]: 'Въведете валидно ЕГН !' }))
                toggleFormToInvalid();
            } else {
                setErrors(state => ({ ...state, [fieldName]: null }))
            }
        }

        if (fieldName == 'childEgn' && EgnValid(fieldValue) && dirDisableChildData == 1 && user.role == 'Director') {
            validateAddressResidenceByEgn(fieldValue)
        } else if (fieldName == 'childEgn' && EgnValid(fieldValue) && formData.childName.length > 0) {
            validateAddressResidence(fieldValue, formData.childName.trim());
        } else if (fieldName == 'childName' && formData.childName.length > 0 && EgnValid(formData.childEgn)) {
            validateAddressResidence(formData.childEgn, fieldValue.trim());
        } else if (formData.childIsEgn == '0' && fieldName == 'childEgn' && formData.childName.length > 0) {
            validateAddressResidence(fieldValue, formData.childName.trim());
        } else if (fieldName == 'childName' && formData.childName.length > 0 && formData.childIsEgn == '0') {
            validateAddressResidence(formData.childEgn, fieldValue.trim());
        }
    }

    const onBlurTwinHandler = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        let twinValidationError = validateTwin(formData, fieldValue, i);
        if (fieldName == 'twinEgn' && formData.twins[i].twinIsEgn == 1) {

            if (!EgnValid(fieldValue)) {
                setErrors(state => ({ ...state, [`${i}${fieldName}`]: 'Въведете валидно ЕГН !' }))
                toggleFormToInvalid();
                return
            } else if (twinValidationError) {
                setErrors(state => ({ ...state, [`${i}${fieldName}`]: twinValidationError }))
                toggleFormToInvalid();
                return
            } else {
                setErrors(state => ({ ...state, [`${i}${fieldName}`]: null }))
            }
        }

        let dublicatedNamesError = validateDublicateChildrenNames(formData)

        if (twinValidationError) {
            setErrors(state => ({ ...state, [`${i}${fieldName}`]: twinValidationError }))
            toggleFormToInvalid();
        } else if (fieldName == 'twinName' && dublicatedNamesError) {
            setErrors(state => ({ ...state, [`${i}${fieldName}`]: dublicatedNamesError }))
            toggleFormToInvalid();
            return
        } else {
            setErrors(state => ({ ...state, [`${i}${fieldName}`]: null }))
        }
    }

    const onBlurWishHandler = (e, i, advCode) => {
        if (e.target.name == `${advCode}_EGN`) {
            if (!validateSiblingEGN(e, i, advCode, formData)
            ) {
                toggleFormToInvalid();
            }
        }

        if (formData.wishes[i][`${advCode}_EGN`] && formData.wishes[i][`${advCode}_NAME`]) {
            validateSibling(formData.wishes[i][`${advCode}_EGN`], formData.wishes[i][`${advCode}_NAME`], advCode, formData.wishes[i].school.id, i);
        }

    }

    const setAutoSedGroup = (i, wish) => {
        if (!siblingIsValid[`${i}K200Error`]
            && wish[`K200_NAME`]
            && wish[`K200_EGN`]
            && wish[`K200_NAME`].length > 0
            && wish[`K200_EGN`].length == 10
        ) {
            if (!formData.wishes[i].sedGroup || formData.wishes[i].sedGroup.code != 'K210') {
                setFormData(prevState => {
                    let wishes = [...prevState.wishes];

                    wishes[i].sedGroup = sedentaryGroups.find(x => x.code == 'K210');

                    return { ...prevState, wishes };
                })

            }

            return true;

        }

        //if (formData.wishes[i].sedGroup) {
        //    setFormData(prevState => {
        //        let wishes = [...prevState.wishes];

        //        wishes[i].sedGroup = null;

        //        return { ...prevState, wishes };
        //    })

        //}

        return false;
    }

    const wishChangeHandler = (e, i, advCode) => {
        let fullFieldName = e.target.name;
        let [advName, prop] = e.target.name.split('_');
        let fieldValue = e.target.value;
        let isCheckbox = e.target.type == 'checkbox';

        setFormData((prevState) => {
            let wishes = [...prevState.wishes];

            if (advName == 'school') {
                let isAlreadySelected = false;

                formData.wishes.forEach(x => {
                    if (x.school.id == fieldValue.id) {
                        isAlreadySelected = true;
                        Swal.fire({
                            title: 'Внимание!',
                            text: 'Училището вече е избрано като желание.',
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })

                        return;
                    }
                })

                if (isAlreadySelected) {
                    wishes[i][e.target.name] = '';
                    return { ...prevState, wishes };
                }

                for (var key in wishes[i]) {
                    if (key.includes('IsEgn')) {
                        wishes[i][key] = '1';
                    } else if (key.includes('EGN')) {
                        wishes[i][key] = '';
                    } else if (key.includes('NAME')) {
                        wishes[i][key] = '';
                    }
                }

                if (autoTimeLived == 0
                    || user.role == 'Municipality'
                    || user.role == 'Admin'
                    || user.role == 'SuperAdmin'
                    || (user.role == "Director" && addressResidence.length == 0 && autoTimeLived == 1)) {
                    wishes[i].sedGroup = null;
                    toggleFormToInvalid();
                }
            }

            if (fullFieldName.includes('NAME') && cyrillicRegex.test(fieldValue) || fieldValue == '') {
                wishes[i][e.target.name] = fieldValue.toUpperCase();
            } else if (fullFieldName.includes('NAME') && !cyrillicRegex.test(fieldValue)) {
                return { ...prevState, wishes };
            } else if (fullFieldName.includes('IsEgn')) {
                removeError(e, i, advCode)
                wishes[i][e.target.name] = fieldValue;
            } else if (fullFieldName.includes('EGN')) {
                if (phoneRegex.test(fieldValue) || fieldValue == '') {
                    wishes[i][e.target.name] = fieldValue.trim();
                }
            } else {
                wishes[i][e.target.name] = isCheckbox ? e.target.checked : fieldValue;
               
                if (parameters.municipality.obshtina_name == 'БОТЕВГРАД' && e.target.name == 'sedGroup' && fieldValue.code == 'K240') {
                    wishes[i]['K120'] = false;
                }
            }

            return { ...prevState, wishes };
        });

        if (isCheckbox && advName == 'K50' && e.target.checked == true) {
            isChildHavePreparatoryGroup(formData.childEgn, formData.childName, formData.wishes[i].school.id, i);
        } else if (isCheckbox && advName == 'K50' && e.target.checked == false) {
            cleanChildHavePreparatoryGroupState(i);
        }
    }



    const addTwin = (e) => {
        e.preventDefault();

        let newState = { ...formData }
        let twinNumber = newState.twins.length + 1;

        if (twinNumber > 3) {
            Swal.fire({
                title: 'Внимание!',
                text: 'Не може да добавяте повече от три близнака',
                icon: 'warning',
                confirmButtonText: 'ОК'
            })

            return
        }

        newState.twins.push({ twinNumber, twinIsEgn: '1', twinEgn: '', twinName: '' });

        toggleFormToInvalid();

        setFormData(newState);
    }

    const removeTwin = (e) => {
        e.preventDefault();

        let newState = { ...formData }

        newState.twins.pop();

        toggleFormToInvalid();

        setFormData(newState);
    }

    const addWish = (e) => {
        e.preventDefault();

        let newState = { ...formData }

        if (newState.wishes.length >= maxDesires) {
            Swal.fire({
                title: 'Внимание!',
                text: 'Достигнали сте максималния брой желания.',
                icon: 'warning',
                confirmButtonText: 'ОК'
            })

            return
        }

        const advantagesMap = advantages.reduce((acc, x) => {
            if (x.code === 'K100') {
                acc['K100_NAME'] = '';
                acc['K100_EGN'] = '';
                acc['K100_IsEgn'] = true;
            } else if (x.code === 'K200') {
                acc['K200_NAME'] = '';
                acc['K200_EGN'] = '';
                acc['K200_IsEgn'] = true;
            } else {
                acc[x.code] = false;
            }
            return acc;
        }, {});

        newState.wishes.push({ id: '', school: '', ...advantagesMap });

        toggleFormToInvalid();

        setFormData(newState);
    }

    const removeWish = (e, i) => {
        e.preventDefault();
        Swal.fire({
            title: "Внимание !",
            text: `Сигурни ли сте, че искате да изтриете това желание?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Не",
            confirmButtonText: "Да"
        }).then((result) => {
            if (result.isConfirmed) {
                let newState = { ...formData }

                newState.wishes.pop();

                toggleFormToInvalid();

                setFormData(newState);
            }
        });
    }

    const isTwinsInValid = () => {
        if (formData.twins.length == 0) {
            return false;
        } else if (formData.twins.length > 0 && formData.twins.some(x => x.twinEgn == '' && x.twinName == '')) {
            return true
        } else {
            return false
        }
    }

    const scrollToComponent = (ref) => {
        const scrollToRef = ref.current;
        if (scrollToRef) {
            const elementOffset = scrollToRef.getBoundingClientRect().top;
            const offset = elementOffset - 100;

            const duration = 500;

            const startingY = window.pageYOffset;
            const diff = offset;
            let start;

            window.requestAnimationFrame(function step(timestamp) {
                if (!start) start = timestamp;
                const time = timestamp - start;
                const percent = Math.min(time / duration, 1);

                window.scrollTo(0, startingY + diff * percent + 70);

                if (time < duration) {
                    window.requestAnimationFrame(step);
                }
            });
        }
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        let body = MunicipalityRegisterBodyFormat(formData);

        if (user.role == 'Municipality' || user.role == 'SuperAdmin' || user.role == 'Admin') {
            createMunicipalityApplication(body)
                .then((data) => {
                    if (data.status == 400) {
                        Swal.fire({
                            title: 'Внимание!',
                            text: data.message,
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    } else {
                        setRegId(data);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    Swal.fire({
                        title: 'Внимание!',
                        text: err.message,
                        icon: 'error',
                        confirmButtonText: 'ОК'
                    })
                    setLoading(false);
                })
        } else {
            createFreeAddressTextApplication(body)
                .then((data) => {
                    if (data.status == 400) {
                        Swal.fire({
                            title: 'Внимание!',
                            text: data.message,
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    } else {
                        setRegId(data);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    Swal.fire({
                        title: 'Внимание!',
                        text: err.message,
                        icon: 'error',
                        confirmButtonText: 'ОК'
                    })
                    setLoading(false);
                })
        }


    }

    const getApplicationPDF = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            let response = '';
            const saltRounds = 12;
            const hashedParentEgn = await bcrypt.hash(formData.parentEgn, saltRounds);
            let downloadUrl = await fileService.getApplicationPDF({ regId: regId, hashedParentEgn: hashedParentEgn })

            if (downloadUrl) {
                window.open(downloadUrl, '_blank');
            }

            setLoading(false);
        } catch (error) {
            console.error('Error fetching PDF:', error);
            Swal.fire({
                title: 'Внимание!',
                text: error.message,
                icon: 'error',
                confirmButtonText: 'ОК'
            })
        }
    }

    return (
        <div className="d-flex container-mob gap-5 w-100-mob m-0-mob">
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />

            {isOpenForRegister ? <>
                {regId
                    ? <>
                        <div className="children_data">
                            <div className="title_entr text-success">Регистрацията на заявлението е успешна</div>
                            <div className="htext text-center">Вашият номер на регистрираното заявление е <b>{regId}</b></div>
                            {roles.includes(user.role)
                                ? <p className="text-md-center">За да изтеглите вашето заявление <a href="/#" onClick={getApplicationPDF}>натиснете тук</a></p>
                                : <p className="text-md-center"> За да видите вашето заявление трябва да влезете в системата от <Link to={testReg != 0 ? testReg : "/parent-login"}>тук</Link></p>}

                        </div>
                    </>
                    : <>
                        <div className="form-navigator position-sticky nav-mobile" style={{ top: '50px' }}>
                            <button className="nav-l" onClick={() => scrollToComponent(parentDataRef)}>Данни за родител</button>
                            <button className="nav-l" onClick={() => scrollToComponent(childrenDataRef)}>Данни за дете</button>
                            <button className="nav-l" onClick={() => scrollToComponent(commonAdvantagesRef)}>Предимства</button>
                            <button className="nav-l" onClick={() => scrollToComponent(wishesRef)}>Желания</button>
                        </div>
                        <div className="w-80 form-body-mob w-100-mob">
                            <div className="title_entr">Регистрация на заявление</div>

                            <div className="reg_cont">

                                <form className="form w-100 d-flex flex-row justify-content-between align-items-center flex-wrap" action="parent_ack" method="post">
                                    <ParentData
                                        ref={parentDataRef}
                                        id='parentData'
                                        formData={formData}
                                        handleChange={handleChange}
                                        onBlurValidate={onBlurValidate}
                                        errors={errors}
                                        isMunicipality={true}
                                    />
                                    <ChildrenData
                                        ref={childrenDataRef}
                                        id='childrenData'
                                        formData={formData}
                                        handleChange={handleChange}
                                        addTwin={addTwin}
                                        removeTwin={removeTwin}
                                        onBlurValidate={onBlurValidate}
                                        onBlurTwins={onBlurTwinHandler}
                                        errors={errors}
                                        isMunicipality={true}
                                    />
                                    <CommonAdvantages
                                        ref={commonAdvantagesRef}
                                        id='commonAdvantages'
                                        formData={formData}
                                        handleChange={commonAdvatagesChangeHandler}
                                    />
                                    < Wishes
                                        ref={wishesRef}
                                        id='wishes'
                                        formData={formData}
                                        wishChangeHandler={wishChangeHandler}
                                        addWish={addWish}
                                        removeWish={removeWish}
                                        cleanSiblingInputFields={cleanSiblingInputFields}
                                        isMunicipality={true}
                                        onBlurWishHandler={onBlurWishHandler}
                                        setAutoSedGroup={setAutoSedGroup}
                                    />
                                    <AdditionalInfo
                                        ref={additionalRef}
                                        formData={formData}
                                        handleChange={handleChange}
                                        isMunicipality={true}
                                    />
                                    <button
                                        className="btn but_add mb-3 mt-3"
                                        disabled={!isFormValid || Object.values(dontHaveCompletedGroup).some(x => x !== '') || Object.values(siblingIsValid).some(x => x.length > 0) || isTwinsInValid()}
                                        onClick={onSubmit}
                                    >
                                        Завърши регистрацията
                                    </button>
                                </form>
                            </div>

                        </div>
                    </>
                }</> : <>
                <div className="reg_cl">Системата e затворена за регистрация и редакция на заявления. </div>
            </>}
        </div>
    )
}